@let isLoggedIn = meFeature.auth.selectors.isLoggedIn.asSignal();

<div class="atn-root">
  @defer (when isLoggedIn) {
    <atn-platform />
  } @placeholder (minimum 4.7s) {
    <atn-ds-splash-screen
      title="Attain Apps"
      subtitle="Lead Boldly.  Execute Wisely."
      [initialLoadingMessages]="[
        'Authenticating...',
        'Loading content...',
        'Initializing applications...',
        'Waking up the AI assistants...',
      ]"
      [repeatableLoadingMessages]="[
        'Retrieving user data...',
        'Applying configuration settings...',
        'Synchronizing with servers...',
        'Preparing user workspace...',
        'Untangling network cables...',
        'Convincing servers to cooperate...',
        'Almost there... probably...',
      ]"
    />
  }
</div>
